import * as React from "react";
import { useContext } from "react";
import { singleton } from "../../../logic/singleton";
const InteractiveContext = singleton(
  "views.components.contexts.InteractiveContext",
  () => React.createContext("interactive")
);
export const useIsInteractiveMode = () => useContext(InteractiveContext) === "interactive";
export const useIsReadOnlyMode = () => useContext(InteractiveContext) === "read-only";
export default InteractiveContext;
